var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11 14L37 14L37 40L11 40L11 14Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "charla"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z",
    id: "Ellipse-2",
    fill: "#0D9C7A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14L37 14L37 40L11 40L11 14Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11 15.10498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7241 7.14058L19.7241 16.6176C19.7241 17.8378 18.7348 18.8271 17.5146 18.8271L9.86207 18.859L5.37931 23.79L5.37931 18.859L2.20955 18.859C0.989345 18.859 0 17.8696 0 16.6494L0 7.17241C0 5.9522 0.989345 4.96286 2.20955 4.96286L17.5141 4.93103C18.7348 4.93103 19.7241 5.92038 19.7241 7.14058L19.7241 7.14058Z",
    id: "Shape",
    fill: "#BDFCED",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86207 9.86213L4.03449 9.86213C3.78659 9.86213 3.58621 9.6613 3.58621 9.41385C3.58621 9.1664 3.78659 8.96558 4.03449 8.96558L9.86207 8.96558C10.11 8.96558 10.3103 9.1664 10.3103 9.41385C10.3103 9.6613 10.11 9.86213 9.86207 9.86213L9.86207 9.86213Z",
    id: "Shape",
    fill: "#232C4A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6897 12.5517L4.03449 12.5517C3.78659 12.5517 3.58621 12.3509 3.58621 12.1034C3.58621 11.856 3.78659 11.6552 4.03449 11.6552L15.6897 11.6552C15.9376 11.6552 16.1379 11.856 16.1379 12.1034C16.1379 12.3509 15.9376 12.5517 15.6897 12.5517L15.6897 12.5517Z",
    id: "Shape",
    fill: "#232C4A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6897 15.2414L4.03449 15.2414C3.78659 15.2414 3.58621 15.0406 3.58621 14.7931C3.58621 14.5457 3.78659 14.3448 4.03449 14.3448L15.6897 14.3448C15.9376 14.3448 16.1379 14.5457 16.1379 14.7931C16.1379 15.0406 15.9376 15.2414 15.6897 15.2414L15.6897 15.2414Z",
    id: "Shape",
    fill: "#232C4A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7905 0.0313794L8.48588 0C7.26522 0 6.27588 0.989345 6.27588 2.20955L6.27588 4.9539L17.5146 4.93059C18.7348 4.93059 19.7242 5.91993 19.7242 7.14059L19.7242 15.4072L22.8621 18.859L22.8621 13.9279L23.7905 13.9279C25.0107 13.9279 26 12.9386 26 11.7184L26 2.24138C26 1.02072 25.0107 0.0313794 23.7905 0.0313794L23.7905 0.0313794Z",
    id: "Shape",
    fill: "#232C4A",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesIcon);
export default __webpack_public_path__ + "static/media/messagesIcon.b5702f3de9f246358be05c9001976f42.svg";
export { ForwardRef as ReactComponent };